/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomQuestionnaireAnswerOption } from './CustomQuestionnaireAnswerOption';
import {
  CustomQuestionnaireAnswerOptionFromJSON,
  CustomQuestionnaireAnswerOptionFromJSONTyped,
  CustomQuestionnaireAnswerOptionToJSON,
} from './CustomQuestionnaireAnswerOption';

/**
 *
 * @export
 * @interface CustomQuestionnaireRadioAnswerRead
 */
export interface CustomQuestionnaireRadioAnswerRead {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireRadioAnswerRead
   */
  id?: number;
  /**
   *
   * @type {CustomQuestionnaireAnswerOption}
   * @memberof CustomQuestionnaireRadioAnswerRead
   */
  readonly value: CustomQuestionnaireAnswerOption;
}

/**
 * Check if a given object implements the CustomQuestionnaireRadioAnswerRead interface.
 */
export function instanceOfCustomQuestionnaireRadioAnswerRead(
  value: object,
): value is CustomQuestionnaireRadioAnswerRead {
  if (!('value' in value) || value['value'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireRadioAnswerReadFromJSON(json: any): CustomQuestionnaireRadioAnswerRead {
  return CustomQuestionnaireRadioAnswerReadFromJSONTyped(json, false);
}

export function CustomQuestionnaireRadioAnswerReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireRadioAnswerRead {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    value: CustomQuestionnaireAnswerOptionFromJSON(json['value']),
  };
}

export function CustomQuestionnaireRadioAnswerReadToJSON(
  value?: Omit<CustomQuestionnaireRadioAnswerRead, 'value'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
  };
}
